// extracted by mini-css-extract-plugin
export default {"icon":"PrettyPrintButtonLight__icon___FEfA6"};